import { axiosInstance as axios } from '../../boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 取得案件結案狀態
    GetClosureStatusList({ rootGetters }, request) {
      return axios
        .get('Common/ClosureStatusList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //根据查询条件获取账号
    GetUserByCondition({ commit, rootGetters }, request) {
      return axios
        .get('Common/GetUserByCondition', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得MES付款方式
    GetMesPayType({ commit, rootGetters }, request) {
      return axios
        .get('Common/GetMesPayType', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得預付款確認狀態
    GetConfirmStatus({ commit, rootGetters }, request) {
      return axios
        .get('Common/GetAdvancePaymentConfirmStatus')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得代工案件類別
    GetOemDesignCaseType({ commit, rootGetters }, request) {
      return axios
        .get('Common/GetOemDesignCaseType')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 代工自動產生正式料號號碼
    GetAutoCabinetNo({ commit, rootGetters }, request) {
      return axios
        .get('Common/GetAutoCabinetNo', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得訂單責任單位
    GetMesAbnormalDutyDep({ commit, rootGetters }) {
      return axios
        .get('Common/GetMesAbnormalDutyDep')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得訂單異況審核單位
    GetMesAbnormalApprovalDep({ commit, rootGetters }) {
      return axios
        .get('Common/GetMesAbnormalApprovalDep')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得MES付款方式
    GetOrderPaymentType({ commit, rootGetters }, request) {
      return axios
        .get('Common/GetOrderPaymentType')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
